/**
 * @description
 * antd 테이블 높이 자동 세팅을 위한 계산
 */
export function getGridTableHeight(header_h) {
    if (header_h == null) {
        header_h = 200;
    }
    let height = 'calc(100vh - ' + header_h + 'px)';
    return height;
}


/**
 * @description
 * 팝업창 위치 크기 및 위치
 */
export function getPopupSizeOption(_width, _height, type) {
    var w_width = Math.ceil(window.innerWidth - 10);
    var w_height = Math.ceil(window.innerHeight - 10);
    if (type == null || type != 'fix') {
        if (_width > w_width) { _width = w_width; };
        if (_height > w_height) { _height = w_height; };
        // _height = _height+100;
    }

    var _left = window.screenLeft + Math.ceil((window.outerWidth - _width) / 2);
    var _top = window.screenTop + Math.ceil((window.outerHeight - _height) / 2);

    const option = 'width=' + _width + ', height=' + _height + ', left=' + _left + ', top=' + _top + ',status=no ,location=no, directoryies=no, scrollbars=true';
    return option;
}

/**
 * @description
 * 자산구분에 따른 서브타이틀
 */
export function getAssetTypeTitle(assetType) {

    const codeList = localStorage.getItem('code_list');
    const codeInfo = JSON.parse(codeList).filter(item => item.type == 'asset_type' && item.value == assetType);

    if (codeInfo.length > 0) {
        return codeInfo[0].text;
    } else {
        return assetType;
    }
}


/**
 * @description
 * today : YYYY-MM-DD (dot)
 */
export function getNowDate(dot) {

    //dot가 ''로 들어오는 경우는 YYYYMMDD로 설정되도록 수정
    if (dot == undefined || dot == 'undefined' || dot == null) {
        dot = '-';
    }
    var d_dot = dot;
    var today = new Date();
    var year = today.getFullYear();
    var month = ('0' + (today.getMonth() + 1)).slice(-2);
    var day = ('0' + today.getDate()).slice(-2);
    var dateString = year + d_dot + month + d_dot + day;

    return dateString;
}


/**
 * @description
 * YYYYMMDD to YYYY.MM.DD
 * @return string
 * YYYY.MM.DD
 */
export function addYmdDot(dateYmd, dot) {
    if (dateYmd && dateYmd.length == 8) {
        return dateYmd.replace(/(\d{4})(\d{2})(\d{2})/, `$1${dot}$2${dot}$3`);
    } else {
        return dateYmd;
    }
}

/**
 * @description
 * YYYYMMDD to YYYY.MM.DD HH:MM
 * @return string
 * YYYY.MM.DD HH:MM:SS
 */
export function addYmdHmsDot(dateYmdHms, dot) {
    if (dateYmdHms && dateYmdHms.length == 12) {
        return dateYmdHms.replace(/(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})/, `$1${dot}$2${dot}$3 $4:$5`);
    } else if (dateYmdHms && dateYmdHms.length == 14) {
        return dateYmdHms.replace(/(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, `$1${dot}$2${dot}$3 $4:$5:$6`);
    } else {
        return dateYmdHms;
    }
}

export const isEmpty = (v) => v == undefined || v == 'undefined' || v == null || v == '';

export function dateFormatter(value) {
    if (value && value.length > 8) {
        value = value.substring(0, 8);
    }
    return !isNaN(Number(value)) ? addYmdDot(value, '-') : value;
};

export function dateTimeFormatter(value) {
    return !isNaN(Number(value)) ? addYmdHmsDot(value, '-') : value;
};

export function amountFormatter(value) {
    return !isNaN(Number(value)) ? value.toLocaleString() + '' : value;
};

export function floatFormatter(value, fix) {
    return !isNaN(Number(value)) ? value.toFixed(fix ? fix : 2).toLocaleString() + '' : value;
};

/**
 * @description
 * 현재일자에 특정개월수를 더한 값을 조회
 * @return string
 * YYYYMMDD
 */
export function getNowAddMonthDate(addMonths, dot, dateString=null) {
    // 현재 날짜를 가져옵니다.
    const today = dateString ? new Date(dateString) : new Date();
    // addMonths 개월을 더합니다.
    const monthLater = new Date(today.getFullYear(), today.getMonth() + addMonths, today.getDate());    

    // 원하는 형식으로 날짜를 포맷팅합니다.
    const formattedDate = `${monthLater.getFullYear()}${dot}${(monthLater.getMonth() + 1)
        .toString()
        .padStart(2, '0')}${dot}${monthLater.getDate().toString().padStart(2, '0')}`;
    // 결과 출력
    return (formattedDate);
}

export function getNowAddDaysDate(addDays, dot, dateString=null) {
    // 현재 날짜를 가져옵니다.
    const today = dateString ? new Date(dateString) : new Date();
    // addMonths 개월을 더합니다.
    const monthLater = new Date(today.getFullYear(), today.getMonth(), today.getDate()+(addDays));    
    console.log("monthLater : " + monthLater);
    // 원하는 형식으로 날짜를 포맷팅합니다.
    const formattedDate = `${monthLater.getFullYear()}${dot}${(monthLater.getMonth() + 1)
        .toString().padStart(2, '0')}${dot}${monthLater.getDate().toString().padStart(2, '0')}`;
    // 결과 출력
    return (formattedDate);
}
/**
 * @description
 * date형식에 대한 포맷팅 변경
 * @return string
 * 2023-07-23T20:30:42.014054+09:00
 */
export function gatDateTimeFormatter(date) {

    const dateObj = new Date(date);
    const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false, // 24시간 형식 사용
        //timeZoneName: 'short',
    };

    const formattedDate = new Intl.DateTimeFormat('ko-KR', options).format(dateObj);

    return formattedDate;
}

export function isValidate(data, type = "") {
    let vStr = "";

    if (Array.isArray(data)) {
        let count = data.length;
        for (let i = 0; count > i; i++) {

            if (data[i] instanceof Object) {
                if (data[i][type] == vStr) return true;
            } else {
                if (data[i] == vStr) return true;
            }
        }
    } else if (data instanceof Object) {
        // for (const key in data) { }
        if (data[type] == vStr) return true;

    } else {
        if (data == vStr) return true;
    }

    return false;
}


// 텍스트 데이터 줄넘기기 처리
export const dataNewlineProc = (value) => {
    return (
        <>
            {Array.isArray(value?.split('\n')) ?
                value.replace(/\\n/g, '\n').split('\n').map((line, index) => (
                    <p key={index} style={{ margin: '0px' }}>
                        {line}
                    </p>
                )) : ""}
        </>
    );
};

export const dataSingleNewlineProc = (value) => {
    return (
        <>
            {
            Array.isArray(value?.split('\n')) ?
                value.replace(/\\n/g, '\n').split('\n').map((line, index) => (
                    <p key={index} style={{ margin: '0px' }}>
                         {line}
                    </p>
                )) : ""
            }
        </>
    );
};

export const converDataNa = (value) => {
    if (value == -1 || value == "NA") {
        return '-';
    } else {
        return value;
    }
};

export const dataOrgNewlineProc = (value) => {
    if (value) {
        return (
            <>
                {value.split('\n').map((line, index) => (
                    <p key={index} style={{ margin: '0px' }}>
                        {line}
                    </p>
                ))}
            </>
        );
    } else {
        return (
            <>{value}</>
        );
    }
};


// export function getRandomColor(){
//     const letters = '0123456789ABCDEF';
//     let color = '#';
//     for (let i = 0; i < 6; i++) {
//         color += letters[Math.floor(Math.random() * 16)];
//     }
//     return color;
// };

export function getRandomColor(alpha) {
    let color = 'rgba(';
    for (let i = 0; i < 3; i++) {
        color += Math.floor(Math.random() * 256) + ",";
    }
    return [color + alpha + ")", color + 1 + ")"];
};


export function getRandomColor2(idx) {
    const maxCount = 19
    if(Number(idx) >= maxCount) idx = idx%maxCount; 

    const CHART_COLORS = {
        red: ['rgb(255, 99, 132)', 'rgba(255, 99, 132, 0.5)'],
        orange: ['rgb(255, 159, 64)','rgba(255, 159, 64, 0.5)'] ,
        yellow: ['rgb(255, 205, 86)','rgba(255, 205, 86, 0.5)'],
        green: ['rgb(75, 192, 192)','rgba(75, 192, 192, 0.5)'],
        blue: ['rgb(54, 162, 235)','rgba(54, 162, 235, 0.5)'],
        purple: ['rgb(153, 102, 255)','rgba(153, 102, 255, 0.5)'],
        grey: ['rgb(201, 203, 207)','rgba(201, 203, 207, 0.5)'],
        black: ['rgb(0, 0, 0)','rgba(0, 0, 0, 0.5)'],
        brown: ['rgb(165, 42, 42)','rgba(165, 42, 42, 0.5)'],
        pink: ['rgb(255, 192, 203)','rgba(255, 192, 203, 0.5)'],
        cyan: ['rgb(0, 255, 255)','rgba(0, 255, 255, 0.5)'],
        magenta: ['rgb(255, 0, 255)','rgba(255, 0, 255, 0.5)'],
        lime: ['rgb(0, 255, 0)','rgba(0, 255, 0, 0.5)'],
        olive: ['rgb(128, 128, 0)','rgba(128, 128, 0, 0.5)'],
        navy: ['rgb(0, 0, 128)','rgba(0, 0, 128, 0.5)'],
        teal: ['rgb(0, 128, 128)','rgba(0, 128, 128, 0.5)'],
        maroon: ['rgb(128, 0, 0)','rgba(128, 0, 0, 0.5)'],
        silver: ['rgb(192, 192, 192)','rgba(192, 192, 192, 0.5)'],
        gold: ['rgb(255, 215, 0)','rgba(255, 215, 0, 0.5)'],
        coral: ['rgb(255, 127, 80)','rgba(255, 127, 80, 0.5)'],
    };

    const COLORS = [
        CHART_COLORS.red,
        CHART_COLORS.orange,
        CHART_COLORS.yellow,
        CHART_COLORS.green,
        CHART_COLORS.blue,
        CHART_COLORS.purple,
        CHART_COLORS.grey,
        CHART_COLORS.black,
        CHART_COLORS.brown,
        CHART_COLORS.pink,
        CHART_COLORS.cyan,
        CHART_COLORS.magenta,
        CHART_COLORS.lime,
        CHART_COLORS.olive,
        CHART_COLORS.navy,
        CHART_COLORS.teal,
        CHART_COLORS.maroon,
        CHART_COLORS.silver,
        CHART_COLORS.gold,
        CHART_COLORS.coral,
    ];

    return COLORS[idx];
}

export function strToCamelCase(str) {
  return str.replace(/(^|-)([a-z])/g, (_, p1, p2) => p1 + p2.toUpperCase());
}
// const useQueryParams = () => {
//     const searchParams = new URLSearchParams(window.location.search);

//     const getParam = (key) => searchParams.get(key);

//     const getAllParams = () => {
//         const params = {};
//         searchParams.forEach((value, key) => {
//             params[key] = value;
//         });
//         return params;
//     };

//     return { getParam, getAllParams };
// };